import { Box } from "@mui/material";
// import BusinessCreditScore from "./BusinessCreditScore";
// import FlaggedBusiness from "./FlaggedBusiness";
import MonitoredBusiness from "./MonitoredBusiness";

const Monitoring = ({ creditScoreData, businessData, selectedPortfolioId, onClick }) => {
  return (
    <>
      {selectedPortfolioId ? (
        <Box>
          <MonitoredBusiness data={businessData} selectedPortfolioId={selectedPortfolioId} onClick={onClick} />
          {/* <FlaggedBusiness /> */}
          {/* <BusinessCreditScore data={creditScoreData} selectedPortfolioId={selectedPortfolioId} onClick={onClick} /> */}
        </Box>
      ) : null}
    </>
  );
};

export default Monitoring;
